import utils from '@/lib/utils'
import utilsBiz from '@/lib/utilsBiz'
import _ from 'lodash'
import api from '@/lib/api'

const localFields = ['user.id', 'user.username', 'terminal.id']
const sessionFields = ['token', 'user.id', 'terminal.id']

export default function ({ storageKey }) {
  function load (state) {
    utils.loadStorage(state, localFields, localStorage, storageKey)
    utils.loadStorage(state, sessionFields, sessionStorage, storageKey)
    return state
  }
  function save (state) {
    utils.saveStorage(state, localFields, localStorage, storageKey)
    utils.saveStorage(state, sessionFields, sessionStorage, storageKey)
  }
  function clearSession () {
    utils.saveStorage({}, sessionFields, sessionStorage, storageKey)
  }
  const state = {
    // 登录用户
    user: {
      // local/session
      id: null,
      // local
      username: null
    },

    terminal: {
      // local/session
      id: null
    },

    app: {
      id: null
    },

    // session
    token: null,

    config: {
      items: null,
      model: null
    },
    patientNo: ''
  }

  const initialState = _.cloneDeep(state)
  // 从 localStorage & sessionStorage 加载信息
  load(state)

  return {
    namespaced: true,
    state,
    getters: {
      authorized: state => !!state.token,
      fetched: (state, getters) => {
        return Boolean(state.user?.id)
      },
      configLoaded: state => !!state.config?.items,
      configModel: state => state.config?.model
    },
    mutations: {
      setPatientNo (state, patientNo) {
        state.patientNo = patientNo
      },
      login (state, { userId, username, token }) {
        if (state.user?.id !== userId) {
          state.user = {}
        }
        _.set(state, 'user.id', userId)
        state.user.username = username
        state.token = token
        console.log('save-login', state)
        save(state)
      },
      fetch (state, { user, app }) {
        if (!state.token ||
          ((state.user?.id ?? null) !== (user?.id ?? null))) {
          console.warn('授权信息状态前后不一致:', state, { user })
        }
        state.user = user
        save(state)
      },
      expire (state) {
        state.token = null
        save(state)
      },
      logout (state) {
        clearSession()
        const newState = load(_.cloneDeep(initialState))
        Object.assign(state, newState)
        state.user = {}
        save(state)
      },
      setConfig (state, items) {
        state.config.items = items
        state.config.model = utilsBiz.buildConfig(items)
      }
    },
    actions: {
      async loadConfig ({ state, getters, commit }, { force = false } = {}) {
        if (!force && getters.configLoaded) return true
        const searchResult = await api.bis.post('/sys/config/search', {
          merge: true,
          scopes: [
            { scopeType: 'app', scopeToken: state.app?.id },
            { scopeType: 'terminal', scopeToken: state.terminal?.id },
            { scopeType: 'user', scopeToken: state.user?.id }
          ]
        })
        searchResult.notifyIfFail()
        if (searchResult.success) {
          commit('setConfig', searchResult.data.items)
        }
        return searchResult.success
      }
    }
  }
}
